<script>
function noop() {}
import rarUrl from '@/assets/images/rar.png'
import { domainApi } from '@/utils/domain';
export default {
    props: {
        action: {
            type: String,
            // required: true
            default:''
        },
        headers: {
            type: Object,
            default() {
                return {};
            }
        },
        data: Object,
        multiple: Boolean,
        name: {
            type: String,
            default: 'file'
        },
        link: {
            type:Boolean,
            default:false
        },
        drag: Boolean,
        dragger: Boolean,
        withCredentials: Boolean,
        accept: String,
        type: {
            type: String,
            default: 'select'
        },
        beforeUpload: Function,
        beforeRemove: Function,
        onRemove: {
            type: Function,
            default: noop
        },
        onChange: {
            type: Function,
            default: noop
        },
        onPreview: {
            type: Function,
            default: noop
        },
        onSuccess: {
            type: Function,
            default: noop
        },
        onProgress: {
            type: Function,
            default: noop
        },
        onError: {
            type: Function,
            default: noop
        },
        fileList: {
            type: Array,
            default() {
                return [];
            }
        },
        autoUpload: {
            type: Boolean,
            default: true
        },
        uploadType:{
            type:String,
            default:'many'
        },
        httpRequest: Function,
        disabled: Boolean,
        limit: Number,
        onExceed: {
            type: Function,
            default: noop
        },
        fileType:{
            type: String,
            default: 'image'
        },
        keyString:{
            type:String,
            default:'image'
        },
        autoClear: {
            type: Boolean,
            default: true
        },
        userClear: {
            type: Boolean,
            default: true
        },        
        completeUrl: {
            type: Boolean,
            default: false
        }
    },
    computed: {
    },
    data() {
        return {
            showFileList:true,
            showSingleImg:false,
            fileName: '',
            contentSrc:'',
			listType:'picture',
			show:false,
            uploadFileList:this.fileList,
            progressWidth:0,
        };
	},

	watch:{
		fileList(value){
			if (this.uploadType === 'single') {
                if (value.length>0) {
                    this.showSingleImg = true;
                    this.fileName = value[0].name;
                    if(this.completeUrl){
                        this.contentSrc = value[0].url;
                        return false;
                    }
                    if(value[0].url == ''){
                        this.contentSrc = value[0].url;
                    }else{
                        this.contentSrc = domainApi.pic_domain + value[0].url;
                    }

                } else {
                    this.showSingleImg = false;
                }// 图片列表为空时显示上传组件为空

            }
            //  else {
            //     this.uploadFileList = value;
            // }
            this.uploadFileList = value;
		}
	},
    mounted() {
        if (this.uploadType === 'single') {
            this.showFileList = false;
            if (this.fileList.length>0) {
                this.showSingleImg = true;
                this.fileName = this.fileList[0].name;
                if(this.completeUrl){
                    this.contentSrc = this.fileList[0].url;
                    return false;
                }
                if(this.fileList[0].url == ''){
                    this.contentSrc = this.fileList[0].url;
                }else{
                    this.contentSrc = domainApi.pic_domain + this.fileList[0].url;
                }
            }

        }
    },
    methods: {
        // handleBefore(res){
        //     this.beforeUpload(res,this.keyString);
        // },

        handleSuccess(res, file,list){
            console.log('uploadSuccess',arguments)
            if(this.uploadType ==='single'){
                this.showSingleImg = true; //在写从列表获取表单时添加，不知道会不会有问题
                this.fileName = file.name;
                if(this.completeUrl){
                    this.onSuccess(res, file,list,this.keyString);
                    this.onChange(file, list);                    
                    this.contentSrc = file.url;
                    return false;
                }
                if(file.url == ''){
                    this.contentSrc = file.url;
                }else{
                    if(file.url == undefined) {
                        this.contentSrc = domainApi.pic_domain + file.response.data.upload_url.url;
                    }else{
                        this.contentSrc = domainApi.pic_domain + file.response.data.upload_url.url;
                    }
                // this.showSingleImg = true;//在写从列表获取表单时添加，不知道会不会有问题
                // if (this.fileType == 'rar') {
                //     this.contentSrc = rarUrl;
                // } else {
                //     console.log("carewd",file.url);
                //     if(file.url == undefined) {
                //         this.contentSrc = file.response.data.upload_url.url;
                //     }else{
                //         this.contentSrc = file.url;
                //     }
                }

            }

            this.onSuccess(res, file,list,this.keyString);
            this.onChange(file, list);
        },

		handleManyPreview(file){
            window.open(file.url)
            this.onPreview(file);
		},

        remove(){

			if(this.uploadType ==='single'){
				this.uploadFileList = [];
				this.showSingleImg = false;
				let file = {...this.fileList[0]}
				file.uid = Date.now();
				file.status = 'success';
				this.onRemove(file,[],this.keyString);
			}
		},

		closeDialog(){
			this.show = false;
		},

		previewImg(){
            if (!this.link) {
                this.show = true;
            } else {
                window.open(this.contentSrc)
            }

        },

        onProgressLine(event, file, fileList){
            this.progressWidth = event.percent;
            if (this.progressWidth == 100) {
                setTimeout(()=>{this.progressWidth = 0;},1000);
            }
            this.onProgress(event, file, fileList);
        },
    },
    render(h) {
        if(this.uploadType === 'single'){
            this.showFileList = false;
        }
        let param = {keyString: this.keyString.includes('audio')?'audio':this.keyString,...this.data};
        // console.log("route",this.$route);
        // let routerInfo = {
        //     routerName: this.$route.name,
        //     routerPath: this.$route.path,
        // };
        // 939 问题，在/mediaSeparate/ageSeparate 无法区分具体的routerName,此时用store里 的
        // if(routerInfo.routerPath =='/mediaSeparate/ageSeparate'){
           let routerInfo = this.$store.state.common.routerInfo
           console.log("render -> routerInfo", routerInfo)
        // }
        // console.log("TCL: render -> this.$store", this.$store)
        let header_param = {...routerInfo,...this.headers};
        const uploadData = {
                props : {
                    showFileList:this.showFileList,
                    type: this.type,
                    drag: this.drag,
                    action: this.action,
                    multiple: this.multiple,
                    'before-upload': this.beforeUpload,
                    'with-credentials': this.withCredentials,
                    headers: header_param,
                    disabled: this.disabled,
                    name: this.name,
                    data: param,
                    accept: this.accept,
                    fileList: this.uploadFileList,
                    autoUpload: this.autoUpload,
                    // listType: this.listType,
                    limit: this.limit,
                    'on-exceed': this.onExceed,
                    // 'on-start': this.handleStart,
                    'on-progress': this.onProgressLine,
                    'on-success': this.handleSuccess,
                    'on-error': this.onError,
                    'on-preview': this.handleManyPreview,
                    'on-remove': this.onRemove,
                    'http-request': this.httpRequest
                }
            }
      return (
            <div class='upload-component'>
            {!this.showSingleImg?
                (<el-upload class='upload-plugin' {...uploadData} listType='picture'>
                    <div class={`upload-btn ${this.fileType==='video'?'upload-video-btn':''}`}>
                        <div class='upload-progress-wrap'>
                            <div class='upload-progress' style={`width:${this.progressWidth}%`}></div>
                        </div>
                        <div class='upload-img'>
                            <div class={`upload-default ${this.fileType==='video'?'upload-video-default':''}` }>
                                <i class='el-icon-plus upload-icon'></i>
                            </div>
                            <p>Upload</p>
                        </div>
                    </div>
                    <p class="el-upload__tip">{this.$slots.tip}</p>
                </el-upload>):(
                    <div class="file-wrapper">
                        <div class={`upload-single-box ${this.fileType==='video'?'upload-video-box':''}`}>
                        <div class='upload-progress-wrap'>
                            <div class='upload-progress' style={`width:${this.progressWidth}%`}></div>
                        </div>
                        {this.fileType=='video'?
                            (<div class='upload-default-video'>
                                <video src={this.contentSrc} controls="controls"></video>
                            </div>)
                            :this.fileType=='audio'?(
                                <div class='upload-default-audio'>
                                    <audio src={this.contentSrc}  style='width:240px;' controls="controls"></audio>
                                </div>
                            )
                            :this.fileType=='rar'?(
                                <div class='upload-default-img download-box'>
                                    <img src={rarUrl} />
                                </div>
                            )
                            :(<div class='upload-default-img'>
                                <div class='upload-mask'>
                                    <i class='el-icon-view upload-check-img' onClick={this.previewImg}></i>
                                </div>
                                <img src={this.contentSrc}/>
                            </div>)
                            }
                            <div class={`${this.fileType==='rar'?'rar-name':'other-name'}`}><a href={this.contentSrc} download={this.fileName}>{this.fileName}</a></div>
                            <div class={`upload-single-op ${this.autoClear == true?'':'hide'}`}>
                                <el-upload {...uploadData}  listType='text' class={`upload-single-btn ${this.fileType==='video'?'upload-video-btn':''}`}>
                                    <el-button size='mini'>重新上传</el-button>
                                </el-upload>
                            </div>
                            <i class={`el-icon-close upload-single-close ${this.userClear == true?'':'hide'}`} onClick={this.remove} ></i>
                        </div>
                        <p class="el-upload__singletip">{this.$slots.tip}</p>

                    </div>
                )
            }
			<el-dialog visible={this.show} onClose={this.closeDialog} title={'查看图片'} style="z-index:10;" width="500px">
				<img width="100%" src={this.contentSrc} alt=""/>
			</el-dialog>
        </div>
      )
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
	@import './index.scss';
</style>



